import { AnyAction, Reducer } from 'redux';
import { AuthActionTypes } from './actions';

export interface AuthState {
  loggedIn: boolean;
}

const initialState = {
  loggedIn: false
};

export const authReducer: Reducer<AuthState> = (state: AuthState = initialState, action: AnyAction) => {
  switch (action.type) {
    case AuthActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true
      };

    case AuthActionTypes.AUTH_ERROR:
      return {
        ...state,
        loggedIn: false
      };

    default:
      return state;
  }
};
